import React from 'react';

import copy from '@/content/en.json';
import { pipeline } from '@/utils/pipeline';

interface DocumentProps extends React.PropsWithChildren {
  styles?: React.ReactNode[];
}

const themeInitializationScript = `
  try {
    const theme = localStorage.getItem('arcturus-theme');
    if (theme === 'light' || theme === 'dark') {
      document.documentElement.classList.add(theme);
    }
  } catch {}
`;

function Document({ children, styles }: DocumentProps) {
  return (
    <html lang="en">
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <script dangerouslySetInnerHTML={{ __html: themeInitializationScript }} />
        <title>{copy.site.documentTitle}</title>
        <meta name="description" content={copy.site.documentDescription} />

        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />
        <link rel="manifest" href="/site.webmanifest" />

        <link
          rel="preload"
          href="/fonts/fraunces-latin-variable.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/source-serif-4-latin-variable.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/styles/default.min.css"
        />

        {styles}
      </head>
      <body>
        <div id="arc_root">{children}</div>
      </body>
    </html>
  );
}

export default pipeline(React.memo)(Document) as React.MemoExoticComponent<typeof Document>;
